import { ButtonProps, Link as ChakraLink, LinkProps, useStyleConfig } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { ButtonStyles } from 'components/UI';

const LinkButtonStyles = {
  ...ButtonStyles,
  baseStyle: {
    ...ButtonStyles.baseStyle,
    display: 'inline-block',
    textDecoration: 'none',
    textAlign: 'center',
    _hover: {
      textDecoration: 'none',
    },
  },
};

type LinkButtonProps = LinkProps & {
  to?: string;
  children: React.ReactNode;
  buttonProps?: ButtonProps;
};

const LinkButton = ({
  to = '',
  children,
  variant = 'solid',
  size = 'md',
  buttonProps,
  sx,
  ...props
}: LinkButtonProps) => {
  const styles = useStyleConfig('LinkButton', { variant, size });
  const reactRouterProps =
    to !== ''
      ? {
          as: RouterLink,
          to,
        }
      : {};

  return (
    <ChakraLink variant={variant} sx={{ ...styles, ...(sx ?? {}) }} {...reactRouterProps} {...props}>
      {children}
    </ChakraLink>
  );
};

export { LinkButton, LinkButtonStyles };
